export const COMPANY_TEMPLATE_MAPPING = {
  331: 'DC Wise Data Collection Template for FY 25-26.xlsx',
}